import type { Icon as PhosphorIcon } from "@phosphor-icons/react"
import Link from "next/link"
import type { ReactNode } from "react"
import { MasonryContent } from "./MasonryContent"

interface MasonryWidgetProps {
  href: string
  icon: PhosphorIcon
  productName: string
  widgetName: string
  description: string
  featuredVisual?: ReactNode
  desktopLayout?: "column" | "row"
  height?: number
  className?: string
}

export function MasonryWidget({
  href,
  icon,
  productName,
  widgetName,
  description,
  featuredVisual,
  desktopLayout = "column",
  height = 450,
  className = "",
}: MasonryWidgetProps) {
  const layoutClasses =
    desktopLayout === "row"
      ? "flex flex-col md:flex-row gap-6"
      : "flex flex-col gap-6"

  return (
    <Link
      href={href}
      className={`relative group bg-bg-surface border border-solid border-border-default rounded-xl pt-6 pl-6 overflow-hidden ${layoutClasses} hover:bg-neutral-100 dark:hover:bg-neutral-800/50 hover:border-border-hover transition-colors duration-200 ${className}`}
      style={{ height: `${height}px` }}
    >
      <div
        className={
          desktopLayout === "row"
            ? "shrink-0 w-full md:w-[40%] flex flex-col"
            : "flex flex-col"
        }
      >
        <MasonryContent
          icon={icon}
          productName={productName}
          widgetName={widgetName}
          description={description}
        />
      </div>
      {featuredVisual && (
        <div
          className={
            desktopLayout === "row"
              ? "relative flex-1 min-h-0 mt-0 md:mt-5"
              : "relative flex-1 min-h-0"
          }
        >
          {featuredVisual}
        </div>
      )}
    </Link>
  )
}
